import React, { useState, useEffect } from "react";
import {
  FiChevronDown,
  FiChevronRight,
  FiTrash2,
  FiSearch,
} from "react-icons/fi";
import AddUserPopup from "./Add-User-Popup";
import { useSelector } from "react-redux";
import { useToast } from "../../Utils/toastContext";
import { useNavigate } from "react-router-dom";
import { removeSelectedUsers } from "../../Redux/store/selectedUserSlice";
import { useDispatch } from "react-redux";

const AccessibleTable = ({ IsUpdate, investment_id }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();

  const selecteduserIds = useSelector(
    (state) => state.selectedUsers.selectedUsers
  );
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [actualData, setactualData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, settotalEntries] = useState(1);
  const [showRecords, setShowRecords] = useState(10);
  const [totalCount, settotalCount] = useState(0);

  const totalPages = Math.ceil(totalEntries / 10);

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const startEntry = (currentPage - 1) * 10 + 1;
  const endEntry = Math.min(currentPage * 10, totalEntries);

  const handleUserClick = () => {
    setisUserPopOpen(true);
  };
  const GetInvestmentList = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/user/admin/ids?name=${searchTerm}&page=${currentPage}`;
    const headers = {
      "Content-Type": "application/json",
    };
    const bodyData = {
      ids: selecteduserIds.length > 0 ? selecteduserIds : [],
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAll = async () => {
    try {
      const response = await GetInvestmentList();

      if (response.status == 200) {
        setTableData(response.data.users);
        settotalEntries(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setTableData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getAll();
  }, [actualData, searchTerm, currentPage, selecteduserIds]);
  const toggleExpand = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const DeleteUser = async (rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/${investment_id}/remove-specific-investor/${rowId}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const deleteRow = async (e, id) => {
    const deleteRecursive = (data, targetId) => {
      return data
        .map((item) => {
          if (item.id === targetId) return null;
          if (item.children && item.children.length > 0) {
            item.children = deleteRecursive(item.children, targetId);
          }
          return item;
        })
        .filter(Boolean);
    };
    dispatch(removeSelectedUsers(id));

    setTableData((prev) => deleteRecursive(prev, id));
    if (IsUpdate == true) {
      e.preventDefault();
      try {
        const response = await DeleteUser(id);
        if (response.status == 200) {
        } else {
          showToast(response.message, "error");
        }
      } catch (err) {
        showToast(err.message, "error");
      }
    }
  };

  const renderRow = (row, index) => {
    return (
      <React.Fragment key={row.id}>
        <tr className="border-b bg-[#F9F9F9]">
          <td className="px-4 py-3 text-sm text-gray-700">{index + 1}</td>

          <td className="px-4 py-3 text-sm text-gray-700 flex items-center">
            <img
              src="/avatar.svg"
              alt="avatar"
              className="w-6 h-6 rounded-full mr-2"
            />
            {row.first_name} {row.last_name}
          </td>
          <td className="px-4 py-3 text-sm text-gray-700">
            <span
              className={`inline-block px-2 py-1 text-xs rounded-full ${
                row.type === "Customer"
                  ? "bg-blue-100 text-blue-700"
                  : "bg-orange-100 text-orange-700"
              }`}
            >
              {row.user_type}
            </span>
          </td>
          <td className="px-4 py-3 text-sm text-gray-700">{row.unique_id}</td>
          <td className="px-4 py-3 text-sm text-gray-700">
            {row.cash_account}
          </td>
          <td className="px-4 py-3 text-sm text-gray-700 flex justify-end items-center">
            <button
              className="text-red-500 hover:text-red-700 mr-10 focus:outline-none"
              onClick={(e) => deleteRow(e, row.id)}
            >
              <img
                src="/trash.svg" /* Replace with your search icon image */
                alt="Search"
                className=""
              />
            </button>
          </td>
        </tr>
        {/* {hasChildren &&
          expandedRows[row.id] &&
          row.children.map((child) => renderRow(child, level + 1, numbering))} */}
      </React.Fragment>
    );
  };

  return (
    <div className="p-4 bg-white mt-6 shadow-md rounded-lg overflow-auto">
      {/* Top Header Section */}
      <div className="flex items-center justify-between mb-4">
        {/* Title Section */}
        <div className="flex items-center space-x-2">
          <h2 className="text-lg font-medium">
            Accessible to specific customers
          </h2>
        </div>
        {/* Action Buttons Section */}
        <div className="flex flex-col md:flex-row items-center space-x-4">
          {/* Search Bar */}
          <div className="relative w-full max-w-xs">
            <img
              src="/search-normal.svg"
              alt="Close Icon"
              className="h-3 w-3 left-3 top-3 absolute"
            />
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border border-gray-300 rounded-lg py-2 pl-10 pr-3 text-sm"
            />
          </div>
          {/* Add Button */}
          <button
            onClick={() => handleUserClick()}
            className="bg-black mt-2 md:mt-0 text-white px-4 py-2 rounded-lg hover:bg-gray-800 flex items-center"
          >
            <span className="mr-1">+</span> Add
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-white mb-2  border border-gray-200 text-[#8C8C8C]">
            <tr>
              <th className="px-4 py-2 text-left text-sm font-medium"></th>
              <th className="px-4 py-2 text-left text-sm font-medium">Name</th>
              <th className="px-4 py-2 text-left text-sm font-medium">Type</th>
              <th className="px-4 py-2 text-left text-sm font-medium">ID</th>
              <th className="px-4 py-2 text-left text-sm font-medium">
                Cash Account
              </th>
              <th className="px-4 py-2 text-left text-sm font-medium"></th>
            </tr>
          </thead>
          <tbody>{tableData.map((row, index) => renderRow(row, index))}</tbody>
        </table>
      </div>
      {/* Pagination Section */}
      <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
        {/* Entries Info Section */}
        <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
          Showing {showRecords * (currentPage - 1) + 1} to{" "}
          {currentPage === totalPages || totalPages == 0
            ? totalCount
            : Math.min(showRecords * currentPage, tableData.length)}{" "}
          of {totalCount} entries
        </div>

        {/* Pagination Section */}
        <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
          {/* Previous Button */}
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Prev
          </button>

          {/* Page Buttons */}
          {Array.from({ length: Math.min(totalPages, 5) }).map((_, index) => {
            const startPage = Math.max(
              1,
              Math.min(totalPages - 4, currentPage - 2)
            );
            const page = startPage + index;

            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-3 py-1 rounded ${
                  currentPage === page
                    ? "bg-black text-white"
                    : "bg-white border border-gray-300 text-black"
                }`}
              >
                {page}
              </button>
            );
          })}

          {/* Next Button */}
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      </div>
      {isUserPopOpen && (
        <AddUserPopup
          componentName="memberList"
          setactualData={setactualData}
          IsUpdate={IsUpdate}
          investment_id={investment_id}
          onClose={() => setisUserPopOpen(false)}
        />
      )}
    </div>
  );
};

export default AccessibleTable;
